<template>
    <Dialog v-bind="$attrs" v-on="$listeners" :title="title" :hide-buttons="!$attrs.buttons" v-model="dialogVisible">
        <m-text-field v-if="!noSearch"
                      v-model="term"
                      append-icon="search"
                      :placeholder="placeholder"
                      class="mt-0"
                      maxlength="100"
                      outlined
                      hide-details />
        <v-list py-0 class="list">
            <template v-for="(item, index) in filtered">
                <div :key="index">
                    <v-list-item v-if="!$scopedSlots.item" @click="$emit('select', item)" :key="index" class="text--darkgray" :id="description(item).normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(' ', '_').replace(/[^\w\s]/gi, '')">
                        <slot name="item-description" :item="item">
                            {{ description(item) }}
                        </slot>
                    </v-list-item>
                    <slot name="item" :item="item" />
                    <v-divider v-if="index + 1 < filtered.length" />
                </div>
            </template>
            <v-list-item v-if="items.length === 0" class="text--darkgray text-center">
                <v-col>
                    <v-label>Carregando...</v-label>
                </v-col>
            </v-list-item>
            <v-list-item v-else-if="filtered.length === 0" class="text--darkgray text-center">
                <v-col>
                    <v-label>Nenhum resultado</v-label>
                </v-col>
            </v-list-item>
        </v-list>
    </Dialog>
</template>

<script>
  import { isString } from 'lodash'

  export default {
    name: 'ListDialog',
    props: {
      noSearch: Boolean,
      title: String, // remove da tag
      items: { type: Array, default: () => [] },
      searchKeys: { type: Array, default: () => [] },
      itemText: { type: [String, Function] },
      filter: Function,
      placeholder: { type: String, default: 'Digite o que deseja buscar' },
      value: Boolean
    },
    data: () => ({
      term: ''
    }),
    computed: {
      /** @return Function */
      description () {
        const itemText = this.itemText
        if (!itemText) {
          // o itemText não foi passado na props, então cria uma função genérica
          return item => item
        } else if (isString(itemText)) {
          // o itemText é a chave do valor que se quer exibir
          return item => item[itemText]
        } else {
          // o itemText já é uma função
          return itemText
        }
      },
      filtered () {
        if (this.noSearch) {
          return this.items
        } else if (!this.searchKeys || !this.searchKeys.length) {
          console.error('ListDialog: searchKeys prop is required')
        } else if (this.items) {
          return this.items.filter(this.filter || this._filter)
        }
        return []
      },
      dialogVisible: {
        get () {
          return this.value
        },
        set (val) {
          this.$emit('input', val)
        }
      }
    },
    watch: {
      value (isOpen) {
        document.documentElement.style.overflow = isOpen ? 'hidden' : 'auto'
      }
    },
    beforeDestroy () {
      document.documentElement.style.overflow = 'auto'
    },
    methods: {
      _filter (item) {
        const term = this.term.toLowerCase()
        return !!this.searchKeys.find(key => (item[key] + '').toLowerCase().includes(term))
      }
    }
  }
</script>

<style scoped>
    .list {
        height: 250px;
        overflow-y: auto;
        padding: 0;
    }
</style>
